import React from 'react'
import {MdPanTool} from 'react-icons/md'
import Notice from '@components/V3/Notice'
import Text from '@components/V3/Text'
import useOrder from '@page-components/TrackV2/hooks/useOrder.main'
import {useTranslation} from 'next-i18next'

export default function OlderThan18Warning() {
  const {t} = useTranslation('tracking', {keyPrefix: 'olderThan18'})
  const {order} = useOrder()

  if (order?.specialRequirementsIds?.includes('forOlderThan18') === false) return null

  return (
    <Notice level="warning">
      <div className="flex gap-2 items-center">
        <div className="w-8">
          <MdPanTool size={24} />
        </div>
        <Text type="caption" className="!text-yellow-700">
          {t('warning')}
        </Text>
      </div>
    </Notice>
  )
}
